import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantService } from 'src/app/tenant/tenant.service';
import { member } from '../models/member.model';
import { GlobalService } from '../services/global.service';
import { MemberService } from '../services/member.service';
import { withLoadingDeadline } from '../loading-spinner/with-loading-deadline';

@Component({
    selector: 'app-member-header',
    templateUrl: './member-header.component.html',
    styleUrls: ['./member-header.component.scss'],
    standalone: false
})
export class MemberHeaderComponent implements OnInit {
  @Input() MemberId: string;
  @Input() hidePicture: boolean = true;
  @Output() completedDisplay = new EventEmitter();
  public member: member;
  public subdomain: string = '';
  public isLoading: boolean = true;
  public isNumeric: boolean = false;
  loadError = false;

  constructor(
    private _memberService: MemberService,
    private tenantService: TenantService,
    public globalService: GlobalService
  ) { }

  async ngOnInit() {
    this.loadError = false;
    try {
    this._memberService.isLoading = true;
    this.isLoading = true;
    this.subdomain = this.tenantService.getTenant();
    this.isNumeric = isNaN(Number(this.MemberId)) == false;
    this.hidePicture = this.isNumeric == false? false: this.hidePicture;
    if (this.isNumeric)
      this.member = await withLoadingDeadline(this._memberService.getMember(parseInt(this.MemberId)));
    else
      this.member = await withLoadingDeadline(this._memberService.getMemberFromAccount(this.MemberId));
    if (!this.member) throw new Error('Member response missing');
    this.member.lastName = this.maskdata(this.member.lastName);
    if (this.isNumeric != false) {
      this.member.dateOfBirth = this.maskdate(this.member.dateOfBirth);
      if (this.member.pictureUrl == '')
        this.member.pictureUrl = 'assets/images/avatar.png';
    }
    } catch { this.loadError = true; }
    finally {
      this._memberService.isLoading = false;
      this.isLoading = false;
      // Parents must be released even if this child could not render.
      this.completedDisplay.emit(this.loadError ? null : this.member.dateOfBirth);
    }
  }

  maskdata(val: string): string {
    if (this.subdomain == 'demo') return val[0].toUpperCase() + 'XXXXXXXXX';
    return val;
  }

  maskdate(val: Date): Date {
    if (this.subdomain == 'demo') return new Date('01/01/1000');
    return val;
  }
}